import React from "react";

function AuctionEvents(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M11.8633 12.3241L11.198 12.9895L11.6722 13.4637L16.9637 8.17154L16.4895 7.69733L15.7919 8.39557L10.5668 3.1718L11.2644 2.47422L10.7901 2L5.49862 7.29152L5.97283 7.76574L6.63822 7.10036L9.00864 9.47078L2 16.4787L2.47422 16.953L9.48285 9.94433L11.8633 12.3241ZM8.48143 7.9938L11.4616 5.01434L13.9487 7.50147L10.9692 10.4809L8.4821 7.9938H8.48143ZM12.3376 11.8499L11.4434 10.9558L14.4229 7.97636L15.317 8.87046L12.3376 11.8506V11.8499ZM10.0926 3.64601L10.9867 4.54012L8.00654 7.51958L7.11243 6.62547L10.0919 3.64601H10.0926ZM17.3293 17.3869V16.7162C17.3293 15.9764 16.7276 15.3747 15.9878 15.3747H9.95104C9.2112 15.3747 8.60954 15.9764 8.60954 16.7162V17.3869H7.93879V18.0577H18V17.3869H17.3293ZM9.28029 16.7162C9.28029 16.3459 9.58078 16.0454 9.95104 16.0454H15.9878C16.358 16.0454 16.6585 16.3459 16.6585 16.7162V17.3869H9.28029V16.7162Z"
        fill="#666666"
      />
    </svg>
  );
}

export default AuctionEvents;
